import { Component, HostListener, Input } from '@angular/core';
import { ProductAttributeIconComponent } from './product-attribute-icon/product-attribute-icon.component';
import { ProductAttributeByGroup } from 'src/app/models/company-shoes.model';
import { KeyValuePipe } from '@angular/common';

@Component({
  selector: 'app-product-attribute-icon-list',
  imports: [ ProductAttributeIconComponent, KeyValuePipe],
  templateUrl: './product-attribute-icon-list.component.html',
  styleUrl: './product-attribute-icon-list.component.scss',
})
export class ProductAttributeIconListComponent {
  @Input('attributes') attributes: ProductAttributeByGroup | undefined;
  /**
   * Define a title for the list, title can be set to empty string to not show.
   */
  @Input('title') title: string = "Product Features:"

  // Tracks the open popup
  activeAttributeId: number | null = null;

  get hasAttributes(): boolean {
    return !!this.attributes && Object.keys(this.attributes).length > 0;
  }

  // Closes the popup if the user clicks anywhere outside
  @HostListener('document:click')
  clickout() {
    this.activeAttributeId = null;
  }

  handleHoverOpen(id: number | undefined, index: number) {
    this.activeAttributeId = id ?? index;
  }

  handleHoverClose() {
    this.activeAttributeId = null;
  }

  handleToggle(id: number | undefined, index: number, event: Event) {
    event.stopPropagation();
    const safeId = id ?? index;
    this.activeAttributeId = this.activeAttributeId === safeId ? null : safeId;
  }

  handleClose(event: Event) {
    event.stopPropagation();
    this.activeAttributeId = null;
  }
}
